<div class="loading-text" [class]="mode">
    <div class="dot-flashing"></div>
    <span [innerHTML]="text | translate | safeStyle"></span>
</div>
